import _ from 'lodash'
import { ENTRIES_LOADED } from '../constants';

const initialState = {byContentfulId: {}, all:[]};

export default function update(state = initialState, action) {
    switch (action.type) {
        case ENTRIES_LOADED:
            if(action.entries.mp3track) {
                const result = initialState;
                Object.keys(action.entries.mp3track).map(key => {
                    result.byContentfulId[key] = action.entries.mp3track[key];
                    action.entries.mp3track[key].id = action.entries.mp3track[key]._id
                    result.byContentfulId[key].listOnly = true;
                    result.all.push(action.entries.mp3track[key]);
                })
                return result
            }
            break;
    }
    return state;
}
